import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=55157a5c&scoped=true"
import script from "./HelpPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HelpPage.vue?vue&type=style&index=0&id=55157a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55157a5c",
  null
  
)

export default component.exports